module.exports = __webpack_public_path__ + "static/media/collapse.706504cf.svg";